// AGC: Utils exports
export * from './geometry'
export * from './phone'

// AGC: Clamp a number to at most `max` decimal places (default 2)
export function clampDecimals(val: number, max = 2): number {
  const f = Math.pow(10, max)
  return Math.round(val * f) / f
}

// AGC: Clamp a numeric string to at most `max` decimal places (for string-state inputs)
export function clampDecimalStr(val: string, max = 2): string {
  const dot = val.indexOf('.')
  if (dot === -1) return val
  return val.slice(0, dot + max + 1)
}

// AGC: Class name utility - combines class names and handles conflicts
// AGC: Used by shared components for conditional styling
export function cn(...inputs: (string | undefined | null | false | Record<string, boolean>)[]): string {
  const classes: string[] = []
  
  for (const input of inputs) {
    if (!input) continue
    
    if (typeof input === 'string') {
      classes.push(input)
    } else if (typeof input === 'object') {
      // AGC: Handle object syntax like { 'class-name': condition }
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key)
        }
      }
    }
  }
  
  return classes.join(' ')
}


